export const EVENTS = "events";
export const SPEAKERS = "speakers";
export const USERS = "users";
export const ROLES = "roles";
export const LOGGED = "logged";
export const CERTIFICATES = "certificates";
export const LAYOUTS = "layouts";
export const AGENDA = "agenda";
export const AGENDAS = "agendas";
export const CALENDARS = "calendars";
export const TEST_REMINDER = "test-reminder";
export const CHANNELS = "channels";
export const REMINDERS = "reminders";
export const CONTENTS = "content-sections";
export const STYLES = "styles";
export const THEMES = "themes";
export const CONTENTS_CHECK = "check-content-sections";
export const EVALUATIONQUESTION = "evaluationquestions";
export const EVALUATIONQUESTION_CHECK = "check-evaluationquestions";
export const QUIZ = "quiz";
export const QUIZ_QUESTIONS = "quiz-questions";
export const QUIZ_QUESTIONS_CATEGORIES = "quiz-question-categories";
export const QUIZ_QUESTION_OPTIONS = "question-options";
export const MEDIA = "media";
export const CSS_MEDIA = "css-media";
export const DOWNLOAD_ICS = "download-ics";
export const DOWNLOAD_CERTIFICATE = "download";
export const EMAIL_CERTIFICATE = "email";
export const EPISODES = "episodes";
export const EPISODE_CATEGORIES = "episodecategories";
export const EPISODE_TABS = "playertabs";
export const LIVE = "live";
export const LEGALS = "legals";
export const MAILERS = "mailers";
export const FAQS = "faqs";
export const SUBSCRIBERS = "subscribers";
export const SUBSCRIPTIONS = "subscriptions";
export const IMPORTS = "imports";
export const EVALUATIONQUESTIONSCATEGORIES = "evaluationquestionscategories";
export const REPORTS = "reports";
export const REFRESH_REPORTS = "refresh-reports";
export const DOWNLOAD_REPORTS = "download-reports";
export const CERTIFICATELOGS = "certificatelogs";
export const COUNTRIES = "countries";
export const AWS_APPS = "aws-apps";
export const DOMAINS = "domains";
export const ASSOCIATION = "association";
export const PLAYER_CALENDAR = "player-calendar";
export const LOGS = "logs";
export const BLACKBOX = "blackbox";
export const ADMIN_ACCESS_LOG = "request-log";
export const CERTIFICATE_LOG = "certificate-log";
export const FORCED_LOGOUT_LOG = "forced-logout-log";
export const CALENDAR_LOG = "calendar-log";
export const REGISTRATION_EMAIL_LOG = "registration-email-log";
export const WAITING_ROOM = "waiting-room";
export const WAITING_ROOMS = "waitingrooms";
export const ERROR_LOG = "exception-log";
export const JOBS_ERROR_LOG = "failed-job-log";
export const USER_LOGIN_LOG = "user-login-log";
export const EMAIL_HISTORY_LOG = "email-history-log";
export const ENDPOINTS_LOG = "endpoints-log";
export const CHANNEL_SOURCES = "channel_sources";
export const CLOSED_CAPTIONS = "closed_captions";
export const REGISTRATION_FORMS = "registration-forms";
export const ANALYTICS = "analytics";
export const DNS_LOOKUP = "dns-lookup";
export const CHANGE_PASSWORD = "change-password";
export const REFRESH_TOKEN = "refresh-token";
export const ATTACH_MEDIA = "attach-media";
export const DOWNLOADABLE = "downloadable";
export const CONFIGS = "configs"
export const ENUM = "enum"
export const SETTINGS = "settings"
export const ROUTES_LIST = "routes-list"
export const REGISTERED_DOMAINS = "registered-domains"
export const PARKED_DOMAINS = "parked-domains"
export const ATTACHED_DOMAINS = "attached-domains"
export const TICKETS = "tickets"
export const AVAILABLE_DOMAINS = "available-domains"

export const LOGIN = "login";
export const LOGOUT = "logout";
export const PUBLISH = "publish";
export const DISCARD = "discard";
export const CHANGE_ORDER = "change-order";
export const RESTORE = "restore";
export const ATTACH = "attach";
export const DETACH = "detach";
export const TOGGLE = "toggle";
export const BUSY_COUNTRIES = "busy-countries";
export const SET_THEME = "set-theme";
export const SAVE_UPLOADED = "save-uploaded";
export const IMPORT_SUBSCRIPTIONS = "import-subscriptions";
export const EXPORT_SUBSCRIPTIONS = "export-subscriptions";
export const EXPORT_LOGINS = "export-logins";
export const LIVE_START = "live-start";
export const LIVE_END = "live-end";
export const TRACKING_START = "tracking-start";
export const TRACKING_END = "tracking-end";
export const RESET_LIVE = "reset-live";
export const REFRESH_LIVE = "refresh-live";
export const REFRESH_VOD = "refresh-vod";
export const CHANGE_QAA_STATUS = "change-qaa-status";
export const TEST = "test";
export const TOGGLE_INTERNAL = "toggle-internal";
export const SEND_REGISTRATION_EMAIL = "send-registration-email";
export const SUBSCRIBE_TO_CHANNELS = "subscribe-to-channels";
export const CHANGE_SUBSCRIPTION_TYPE = "change-subscription-type";
export const IMPORT_ROLLBACK = "import-rollback";
export const CHANNELS_STATUS = "channels-status";
export const FORCE_USERS_LOGOUT = "force-users-logout";
export const SHARE = "share";
export const IMPORT = "import";
export const IMPORT_CONFIG = "import-config";
export const EXPORT_CONFIG = "export-config";
export const EXPORT_ALL = "export-all";
export const SUBSCRIPTION_ANALYTICS = "subscription-analytics";
export const UPDATE_CONNECTED_USERS = "update-connected-users";
export const CLEAN_QAA = "clean-qaa";
export const SUPPRESSION_LIST = "suppression-list";
export const ATTACHMENTS = "attachments";
export const SORT = "sort";
export const ACCEPT = "accept";
export const REJECT = "reject";
export const GET_USERS = "get-users";
export const TOGGLE_ACTIVE = "toggle_active";
export const SORT_SPEAKERS = "sort-speakers";
export const HIDDEN_SPEAKERS = "hidden-speakers";
export const PUBLISH_THEME_CHANGES = "publish-theme-changes";
export const RESET_THEME_CHANGES = "reset-theme-changes";
export const SET_THEME_VERSION = "set-theme-version";
export const CUSTOM_SUBSCRIPTIONS_LIST = "custom-subscriptions-list";
export const DETACH_MEDIA = "detach-media";
export const CHECK_AVAILABILITY = "check-availability";
export const REGISTER = "register";
export const CREATE_CERTIFICATE = "create-certificate";
export const UPDATE_URL = "update-url";
export const NOTIFICATIONS = "notifications"
export const ACTIVITY_LOGS = "activity-logs"
export const DOWNLOAD = "download"
export const SUBSCRIBER_NOTIFICATIONS = "subscriber_notifications"